import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const InvalidPasswordErrorContainer = styled.div`
  font-family: ${props => props.theme.texts.bodySRegular.fontFamily};
  font-size: ${props => props.theme.texts.bodySRegular.fontSize};
  color: ${props => props.theme.colors.danger.onSurface};

  ul {
    padding-left: ${props => props.theme.spacing.sp16};
  }
`
